import axios from "axios";
import { GENERAL_URL_API } from "../../../urls";

/**
 * Deletes a super institute.
 *
 * @async
 * @param {Object} instituto - The object containing super institute information.
 * @param {string} instituto.nombre - The name of the super institute to delete.
 * @returns {Promise<Object>} A promise that resolves to the response data from the API.
 */
export const eliminarSuperInstituto = async ({ nombre, id }) => {
  const fd = new FormData();
  fd.append("nombre", nombre);
  fd.append("id", id);

  const { data } = await axios.post(
    `${GENERAL_URL_API}/superInstituto/eliminarSuperInstituto`,
    fd,
    {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data;
}; 